__turbopack_context__.v({
  "footer": "Footer-module__S6Hkya__footer",
  "footerBtn": "Footer-module__S6Hkya__footerBtn",
  "footerBtnWrapper": "Footer-module__S6Hkya__footerBtnWrapper",
  "footerFullWidth": "Footer-module__S6Hkya__footerFullWidth",
  "footerLogoText": "Footer-module__S6Hkya__footerLogoText",
  "footerMainRow": "Footer-module__S6Hkya__footerMainRow",
  "footerMiddleText": "Footer-module__S6Hkya__footerMiddleText",
  "footerTop": "Footer-module__S6Hkya__footerTop",
  "separator": "Footer-module__S6Hkya__separator",
  "socialIcons": "Footer-module__S6Hkya__socialIcons",
  "whaleImage": "Footer-module__S6Hkya__whaleImage",
});
